export default [
  'SUCCESS',
  'FAILED',
  'PROCESSING',
  'INIT',
  'EXCEEDS_SIZE_LIMIT',
];
